var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolatility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01015 4.48589H5.38733C5.17479 4.48589 5.00251 4.65826 5.00251 4.87071V12.5137C5.00251 13.663 5.97866 14.54 7.02532 14.4986C7.23182 14.4905 7.39497 14.3207 7.39497 14.1141V4.87071C7.39497 4.65816 7.22269 4.48589 7.01015 4.48589Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69644 1.66257L3.17637 6.36509C2.99001 6.61403 3.15812 6.98051 3.49554 6.98051H7.39497V1.88563C7.39497 1.52015 6.92783 1.35342 6.69644 1.66257Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97514 1.5014C8.76864 1.50954 8.60549 1.67934 8.60549 1.88593V11.1293C8.60549 11.3418 8.77777 11.5141 8.99031 11.5141H10.6131C10.8257 11.5141 10.998 11.3418 10.998 11.1293V3.48633C10.998 2.33711 10.0218 1.46005 8.97514 1.5014Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5049 9.01949H8.60549V14.1036C8.60549 14.493 9.08057 14.636 9.29837 14.345L12.8241 9.63491C13.0105 9.38597 12.8423 9.01949 12.5049 9.01949Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolatility);
export default __webpack_public_path__ + "static/media/volatility.4ca017e9d3e6cd93b8ca8eabd404a276.svg";
export { ForwardRef as ReactComponent };